import React from "react";
import ICalendarLink from "react-icalendar-link";

/**
 * Returns Israel timezone offset for a given date (DST-aware).
 * Israel: UTC+2 (winter), UTC+3 (summer, ~March 28 – Oct 26).
 */
function getIsraelOffset(dateStr) {
  const [y, m, d] = dateStr.split("-").map(Number);
  const march28 = new Date(y, 2, 28);
  const oct26 = new Date(y, 9, 26);
  const eventDate = new Date(y, m - 1, d);
  const isSummer = eventDate >= march28 && eventDate < oct26;
  return isSummer ? "+03:00" : "+02:00";
}

const Cal = (props) => {
  const date = props.data.date.split("T")[0];
  const hourParts = props.data.hour1.split(":");
  const hour = hourParts[0].padStart(2, "0");
  const minute = (hourParts[1] || "00").padStart(2, "0");
  const offset = getIsraelOffset(date);

  const title = props.data.eventType
    ? `${props.data.brideFN} ו${props.data.groomFN} - החתונה!`
    : props.data.calendarName !== ""
      ? props.data.calendarName
      : "אירוע";

  const event = {
    title,
    description: `"${props.data.hall}", ${props.data.waze}`,
    startTime: `${date}T${hour}:${minute}:00${offset}`,
    location: `${props.data.address}, ${props.data.city}`,
  };

  return (
    <ICalendarLink id="hhh" event={event}>
      {props.div}
    </ICalendarLink>
  );
};
export default Cal;
